import { render, staticRenderFns } from "./CandidateDetails.vue?vue&type=template&id=87e315aa&"
import script from "./CandidateDetails.vue?vue&type=script&lang=js&"
export * from "./CandidateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports